import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';

const invitations = [
    {
        image: require('../../assets/images/icons/restaurant.png'),
        name: "Restaurant",
        key: "restaurant"
    }, {
        image: require('../../assets/images/icons/champagne.png'),
        name: "Lounge-Bar",
        key: "lounge"
    }, {
        image: require('../../assets/images/icons/beer.png'),
        name: "Maquis",
        key: "maquis"
    }, {
        image: require('../../assets/images/icons/gaming.png'),
        name: "Gaming",
        key: "gaming"
    }, {
        image: require('../../assets/images/icons/movie.png'),
        name: "Cinema",
        key: "cinema"
    }, {
        image: require('../../assets/images/icons/beach.png'),
        name: "Beach",
        key: "beach"
    }
];

const InviteOffcanvasContent = ({ show, onHide, onSubmit, profile, isLoading }) => {
    const { t } = useTranslation();
    const [selectedInvite, setSelectedInvite] = useState('');
    
    const handleSubmit = () => {
        onSubmit(selectedInvite.toLowerCase());
    };

    return (
        <>
            <div className={`offcanvas offcanvas-bottom ${show ? 'show' : ''}`} 
                 tabIndex="-1" 
                 id="inviteCanvas"
                 style={{ height: 'auto', maxHeight: '85vh' }}>
                <Spin spinning={isLoading} tip={t('invite.loading')} size="large">
                    <div className="offcanvas-header">
                        <div className="offcanvas-title">
                            <h5 className="title">{t('invite.title', { name: profile?.name })}</h5>
                            <p className="text-primary">{t('invite.subtitle')}</p>
                        </div>
                        <button type="button" className="btn-close" onClick={onHide}></button>
                    </div>
                    <div className="offcanvas-body">
                        <div className="radio style-4 row g-2">
                            {invitations.map((invite, index) => (
                                <div key={index} className="col-4">
                                    <label className="radio-label">
                                        <input
                                            type="radio"
                                            name="invitation"
                                            checked={selectedInvite === invite.name}
                                            onChange={() => setSelectedInvite(invite.name)}
                                        />
                                        <span className="checkmark">
                                            <img src={invite.image} alt={t(`invite.types.${invite.key}`)} />
                                            <span className="text">{t(`invite.types.${invite.key}`)}</span>
                                        </span>
                                    </label>
                                </div>
                            ))}
                        </div>
                        <div className="setting-btn-area">
                            <button className="btn btn-primary w-100" 
                                    onClick={handleSubmit} 
                                    disabled={!selectedInvite}>
                                {t('invite.send')}
                            </button>
                        </div>
                    </div>
                </Spin>
            </div>
            {show && <div className="offcanvas-backdrop fade show" onClick={onHide}></div>}
        </>
    );
};

const InviteOffcanvas = (props) => {
    return ReactDOM.createPortal(
        <InviteOffcanvasContent {...props} />,
        document.body
    );
};

export default InviteOffcanvas;
